import { SvgIcon } from "@mui/material"

import { ReactComponent as Icon } from "./emptyIcon.svg"

export const CheckboxIcon = (props) => {
    return (
        <SvgIcon component={Icon} {...props} inheritViewBox />
    )
}